import { Inject, Component, OnInit } from '@angular/core';
import { SnackbarService } from '../services/snackbar.service';
import { SpinnerService } from '../services/spinner.service';
import { DownloadService } from '../services/download.service';
import { AdheridoControllerService, BusquedaAdheridoDTO, DocumentoInteresControllerService, DocumentoInteresModel, EntityControllerService, DeclaracionAdheridoControllerService, CampanacontrollerService, CampanaFilterDTO, CampanaDTO, CampanaPoseedoresControllerService, CvfControllerService } from 'api-rest';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { Router } from '@angular/router';



@Component({
  selector: 'lib-initial-page',
  templateUrl: './initial-page.component.html',
  styleUrls: ['./initial-page.component.scss'],
})
export class InitialPageComponent implements OnInit {

  imagenUrl: string = `/images/img-fondo-botellas.png`;
  numAdheridos: number = 0;
  declaracionEnvases: any;
  campana: any;
  cvfs: any[] = [];
  fechaCampana: string = '';
  defaultSort: string = '';
  currentSort: string = '';
  pageNumber: number = 0;
  pageSize: number = 25;
  documentos: DocumentoInteresModel[] = [];
  documentosAdheridos: DocumentoInteresModel[] = [];
  documentosDeclaracion: DocumentoInteresModel[] = [];
  documentosSDDRAbierto: DocumentoInteresModel[] = [];
  documentosSDDRCerrado: DocumentoInteresModel[] = [];
  documentosPoseedoresFinales: DocumentoInteresModel[] = [];
  documentosAcuerdosGestores: DocumentoInteresModel[] = [];
  documentosPuntoRecogida: DocumentoInteresModel[] = [];

  rolesAdheridos = ['AD_ADHERIDO', 'AD_ENV_CONS', 'AD_ENV_GEST'];
  rolesDeclaracion = ['DE_ADHERIDO', 'DE_ENV_CONS', 'DE_ENV_GEST']; 
  rolesSDDRAbierto = ['SDDR_CA', 'SDDR_CA_ENV_CONS', 'SDDR_CA_ENV_GEST','SDDR_CC', 'SDDR_CC_ENV_CONS', 'SDDR_CC_ENV_GEST'];
  // rolesSDDRCerrado = ['SDDR_CC', 'SDDR_CC_ENV_CONS', 'SDDR_CC_ENV_GEST'];
  //rolesPoseedores = ['PO_POSEEDOR', 'PO_ENV_CONS', 'PO_ENV_GEST', 'PO_APORT_AUTOFACT',];
  //rolesGestores = ['PO_GESTOR','PO_ENV_CONS', 'PO_ENV_GEST'];
  rolesPoseedoresFinales = ['PO_POSEEDOR','PO_ENV_CONS','PO_ENV_GEST','PO_APORT_AUTOFACT','PO_GESTOR','PO_ENV_CONS','PO_ENV_GEST'];
  rolesAcuerdosGestores = ['AG_GESTOR', 'AG_ENV_CONS', 'AG_ENV_GEST', 'AG_POSEEDOR'];
  rolesPuntoRecogida = ['PR_PUNTORECOGIDA' ,'PR_ENV_CONS', 'PR_ENV_GEST', 'PR_GESTOR'];

  mensajePorDefectoDAE: String = "Ha comenzado la <strong>campaña</strong> <br> de <strong>declaración de envases</strong>"
  mensajePorDefectoCVF : String = "Ha comenzado la <strong>campaña</strong> <br> de <strong>Certificado</strong> <br> de <strong>Valorización Final</strong>"
  
  constructor(
    private documentoInteresCtrlSrv: DocumentoInteresControllerService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private downloadSrv: DownloadService,
    private adheridoService: AdheridoControllerService,
    private entityService: EntityControllerService,
    private decAdheridoService: DeclaracionAdheridoControllerService,
    private router: Router,
    private campanaService: CampanacontrollerService,
    private campanaPoseedoresService: CampanaPoseedoresControllerService,
    private cvfService: CvfControllerService,
  ) { }

  esEcoembes: boolean = false;
  step = -1;

  setStep(index: number) {
    this.step = index;
  }
  ngOnInit(): void {
    console.log('Usuario conectado:', this.authService.user);
    console.log('Roles del usuario conectado:', (this.authService.user as any)?.roles);
    this.cargarDocumentos();
    this.esAdheridoEcoembes();
    if (this.canViewResource('DE-ADHERIDO') || this.canViewResource('PO-GESTOR') || this.canViewResource('PO-POSEEDOR')) {
      this.obtenerCampana();
    }
  }

  cargarDocumentos(): void {
    this.spinnerSrv.loadingShow();
    this.documentoInteresCtrlSrv.findAllByUser()
      .subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.documentos = response;
          this.filtrarDocumentos(response);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al consultar los documentos',
            'error'
          );
        },
      });
  }

  filtrarDocumentos(documentos: DocumentoInteresModel[]): void {
    const userRoleEntities = (this.authService.user as any)?.roleEntities || [];
    const userRoles = userRoleEntities.map((re: any) => re.role?.replace(/-/g, '_'));

    this.documentosAdheridos = documentos.filter(doc => 
      (doc as any).roles?.some((role: any) => this.rolesAdheridos.includes(role.role) && userRoles.includes(role.role))
    );
    this.documentosDeclaracion = documentos.filter(doc => 
      (doc as any).roles?.some((role: any) => this.rolesDeclaracion.includes(role.role) && userRoles.includes(role.role))
    );
    this.documentosSDDRAbierto = documentos.filter(doc => 
      (doc as any).roles?.some((role: any) => this.rolesSDDRAbierto.includes(role.role) && userRoles.includes(role.role))
    );
    /*this.documentosSDDRCerrado = documentos.filter(doc => 
      (doc as any).roles?.some((role: any) => this.rolesSDDRCerrado.includes(role.role) && userRoles.includes(role.role))
    );*/
    this.documentosPoseedoresFinales = documentos.filter(doc => 
      (doc as any).roles?.some((role: any) => this.rolesPoseedoresFinales.includes(role.role) && userRoles.includes(role.role))
    );
    this.documentosAcuerdosGestores = documentos.filter(doc => 
      (doc as any).roles?.some((role: any) => this.rolesAcuerdosGestores.includes(role.role) && userRoles.includes(role.role))
    );
        this.documentosPuntoRecogida = documentos.filter(doc => 
      (doc as any).roles?.some((role: any) => this.rolesPuntoRecogida.includes(role.role) && userRoles.includes(role.role))
    );
  }

  descargarDocumento(documento: DocumentoInteresModel): void {
    let byteString: any = documento.documento;
    let fileType = documento.contentType ?? 'application/octet-stream';
    let blob = this.downloadSrv.b64toBlob(byteString, fileType)
    this.downloadSrv.downloadBlob(blob, documento.filename!);
  }

  abrirEnlace(url: string): void {
    window.open(url, '_blank');
  }

  esAdheridoEcoembes() {
    const roleEntities = (this.authService.user as any).roleEntities;
    var adheridosIds = roleEntities?.filter((adheridoRol: any) => adheridoRol.type === 'ADHERIDO')
      .flatMap((adheridoRol: any) => {
        if (adheridoRol.entity == null || adheridoRol.entity == undefined) {
          return [];
        } else if (Array.isArray(adheridoRol.entity)) {
          return adheridoRol.entity;
        } else {
          return [adheridoRol.entity];
        }
      });

    if (adheridosIds && adheridosIds.length > 0) {
      adheridosIds = adheridosIds.filter((x: number, y: number) => {
        return adheridosIds.indexOf(x) == y;
      });
      const filter: BusquedaAdheridoDTO = {
        id: adheridosIds
      };
      var adheridoArray: any;
      this.adheridoService.listarAdheridos({ page: 0, size: 100 }, filter)
        .subscribe({
          next: (response: any) => {
            adheridoArray = response?.datos;
            this.esEcoembes = adheridoArray.some((item: any) => item.scrapDestino?.descripcion?.toLowerCase() === 'ecoembes');
          },
          error: (err) => {
            this.snackBarSrv.showSnackBar('Ha ocurrido un error al comprobar si el usuario tiene Adheridos de Ecoembes', 'error');
            this.esEcoembes = false;
          },
        });
    } else {
      this.esEcoembes = false;
    }


  }

  abrirDeclaracion() {
    this.entityService.obtenerNumeroAdheridos().subscribe({
      next: (response: any) => {
        this.numAdheridos = response;

        if (this.numAdheridos == 1) {
          this.router.navigate(['/attached-app/packaging-declaration-detail', this.declaracionEnvases.id]);
        } else if (this.numAdheridos > 1) {
          this.router.navigate(['/attached-app', 'packaging-declaration-search']);
        }
      },
      error: (err) => {
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al comprobar el número de adheridos del usuario actual', 'error');
      }
    });
  }

  abrirCvf() {
    if (this.cvfs?.length == 1) {
      const cvf = this.cvfs[0];
      let isEditable = false;

      if (this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS')) {
        isEditable = false;
      } else if (this.canViewResource('PO-GESTOR') || this.canViewResource('PO-POSEEDOR')) {
        isEditable = (cvf.estado?.id === 1);
      }
      
      this.router.navigate(['/holders/holders-cvf-detail', cvf.id], { state: { isEditable: isEditable } });
    } else if (this.cvfs?.length > 1) {
      if (this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS')) {
        localStorage.removeItem('cvfTypeFromRoute');
        this.router.navigate(['/holders', 'holders-cvf-search']);
        return;
      }

      const hasGestor = this.cvfs.some(cvf => !cvf.poseedor || (cvf.poseedor && !cvf.poseedor.id));
      const hasPoseedor = this.cvfs.some(cvf => cvf.poseedor && cvf.poseedor.id);

      if (hasGestor) {
        localStorage.setItem('cvfTypeFromRoute', 'gestor');
        this.router.navigate(['/holders', 'holders-cvf-search']);
      } else if (hasPoseedor) {
        localStorage.setItem('cvfTypeFromRoute', 'poseedor');
        this.router.navigate(['/holders', 'holders-cvf-search']);
      } else {
        localStorage.removeItem('cvfTypeFromRoute');
        this.router.navigate(['/holders', 'holders-cvf-search']);
      }
    }

  }

  obtenerCampana() {

    let filtro: CampanaFilterDTO = {};

    if (this.canViewResource('DE-ADHERIDO')) {
      filtro = {
        busquedaCampanaBannerInicial: true,
        tipo: 'DAE',
      }
    }

    const sort = this.currentSort != '' ? this.currentSort : this.defaultSort;
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    let pag = {
      page: page,
      size: this.pageSize,
      sort: [sort],
    };

    if (this.canViewResource('DE-ADHERIDO')) {
      this.campanaService.findAll6(filtro, pag)
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.campana = data.datos[0];
              this.fechaCampana = this.transformarFecha(this.campana?.fechaFinalizacion); 
              if (this.campana) {
                this.decAdheridoService.findDeclaracion(this.campana?.anio, "D", 0).subscribe({
                  next: (response: any) => {
                    this.declaracionEnvases = response;
                    if (!this.declaracionEnvases.id && (this.canViewResource('PO-GESTOR') || this.canViewResource('PO-POSEEDOR'))) {
                      if (this.canViewResource('PO-GESTOR')) {
                        filtro = {
                          busquedaCampanaBannerInicial: true,
                          tipo: 'CVFGestor',
                        }
                      } else if (this.canViewResource('PO-POSEEDOR')) {
                        filtro = {
                          busquedaCampanaBannerInicial: true,
                          tipo: 'CVFPoseedor',
                        }
                      }
                      this.campanaService.findAll6(filtro, pag).subscribe({
                        next: (dataCVF: any) => {
                          if (dataCVF && dataCVF.datos && dataCVF.datos.length > 0) {
                            this.campana = dataCVF.datos[0];
                            this.fechaCampana = this.transformarFecha(this.campana?.fechaFinalizacion);
                            if (this.campana) {
                              this.cvfService.bannerCvfVisible().subscribe({
                                next: (response: any) => {
                                  this.cvfs = response;
                                },
                                error: (err) => {
                                }
                              });
                            }
                          } else {
                            filtro = {
                              busquedaCampanaBannerInicial: true,
                              tipo: 'CVFPoseedor',
                            }

                            this.campanaService.findAll6(filtro, pag).subscribe({
                              next: (dataCVF: any) => {
                                if (dataCVF && dataCVF.datos && dataCVF.datos.length > 0) {
                                  this.campana = dataCVF.datos[0];
                                  this.fechaCampana = this.transformarFecha(this.campana?.fechaFinalizacion);
                                  if (this.campana) {
                                    this.cvfService.bannerCvfVisible().subscribe({
                                      next: (response: any) => {
                                        this.cvfs = response;
                                      },
                                      error: (err) => {
                                      }
                                    });
                                  }
                                }
                              },
                            });
                          }
                        },
                      });
                    }
                  },
                  error: (err) => {
                  }
                });;
              } else {
                
                if (this.canViewResource('PO-GESTOR')) {
                  filtro = {
                    busquedaCampanaBannerInicial: true,
                    tipo: 'CVFGestor',
                  }
                } else if (this.canViewResource('PO-POSEEDOR')) {
                  filtro = {
                    busquedaCampanaBannerInicial: true,
                    tipo: 'CVFPoseedor',
                  }
                }
                this.campanaService.findAll6(filtro, pag).subscribe({
                  next: (dataCVF: any) => {
                    if (dataCVF && dataCVF.datos && dataCVF.datos.length > 0) {
                      this.campana = dataCVF.datos[0];
                      this.fechaCampana = this.transformarFecha(this.campana?.fechaFinalizacion);
                      if (this.campana) {
                        this.cvfService.bannerCvfVisible().subscribe({
                          next: (response: any) => {
                            this.cvfs = response;
                          },
                          error: (err) => {
                          }
                        });
                      }
                    } else {
                      filtro = {
                        busquedaCampanaBannerInicial: true,
                        tipo: 'CVFPoseedor',
                      }

                      this.campanaService.findAll6(filtro, pag).subscribe({
                        next: (dataCVF: any) => {
                          if (dataCVF && dataCVF.datos && dataCVF.datos.length > 0) {
                            this.campana = dataCVF.datos[0];
                            this.fechaCampana = this.transformarFecha(this.campana?.fechaFinalizacion);
                            if (this.campana) {
                              this.cvfService.bannerCvfVisible().subscribe({
                                next: (response: any) => {
                                  this.cvfs = response;
                                },
                                error: (err) => {
                                }
                              });
                            }
                          }
                        },
                      });
                    }
                  },
                });
              }
            }
          },
          error: () => {
          },
        });
    } else if (this.canViewResource('PO-GESTOR') || this.canViewResource('PO-POSEEDOR')) {
      if (this.canViewResource('PO-GESTOR')) {
        filtro = {
          busquedaCampanaBannerInicial: true,
          tipo: 'CVFGestor',
        }
      } else if (this.canViewResource('PO-POSEEDOR')) {
        filtro = {
          busquedaCampanaBannerInicial: true,
          tipo: 'CVFPoseedor',
        }
      }
      this.campanaService.findAll6(filtro, pag)
        .subscribe({
          next: (dataCVF: any) => {
            if (dataCVF && dataCVF.datos && dataCVF.datos.length > 0) {
              this.campana = dataCVF.datos[0];
              this.fechaCampana = this.transformarFecha(this.campana?.fechaFinalizacion);
              if (this.campana) {
                this.cvfService.bannerCvfVisible().subscribe({
                  next: (response: any) => {
                    this.cvfs = response;
                  },
                  error: (err) => {
                  }
                });;
              }
            } else {
              filtro = {
                busquedaCampanaBannerInicial: true,
                tipo: 'CVFPoseedor',
              }

              this.campanaService.findAll6(filtro, pag).subscribe({
                next: (dataCVF: any) => {
                  if (dataCVF && dataCVF.datos && dataCVF.datos.length > 0) {
                    this.campana = dataCVF.datos[0];
                    this.fechaCampana = this.transformarFecha(this.campana?.fechaFinalizacion);
                    if (this.campana) {
                      this.cvfService.bannerCvfVisible().subscribe({
                        next: (response: any) => {
                          this.cvfs = response;
                        },
                        error: (err) => {
                        }
                      });
                    }
                  }
                },
              });
            }
          },
          error: () => {
          },
        });
    }
  }

  transformarFecha(fechaOriginal: string) {
    const fechaObj = new Date(fechaOriginal);

    const dia = fechaObj.getDate();

    const mes = fechaObj.toLocaleDateString('es-ES', { month: 'long' });

    if (!mes) return '';

    const mesCapitalizado = mes.charAt(0).toUpperCase() + mes.slice(1);

    const fechaFinal = `${dia} de ${mesCapitalizado}`;
    return fechaFinal;
  }

  canViewBannerDAE(): boolean {
    return this.canViewResource('DE-ADHERIDO') && !!this.declaracionEnvases?.id && !!this.campana;
  }

  canViewBannerCVF(): boolean {
    if (this.canViewBannerDAE()) {
      return false;
    }
    return (this.canViewResource('PO-GESTOR') || this.canViewResource('PO-POSEEDOR')) && !!this.campana && this.cvfs?.length > 0;
  }


  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }
}

